import { render } from "./ViewPromotions.vue?vue&type=template&id=3bd66832"
import script from "./ViewPromotions.vue?vue&type=script&lang=js"
export * from "./ViewPromotions.vue?vue&type=script&lang=js"

import "./ViewPromotions.vue?vue&type=style&index=0&id=3bd66832&lang=css"

import exportComponent from "/srv/strapi/LessMessAdmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__